/* import __COLOCATED_TEMPLATE__ from './fin-step-reached-list.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();